import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface IReactivateVentureUserAssignmentProps {
  userId: string;
  reason?: string;
}

export const reactivateVentureUserAssignmentService = async ({
  userId,
  reason,
}: IReactivateVentureUserAssignmentProps): Promise<void> => {
  await jhsfBookingsApi.post(`/users/${userId}/venture-assignment/reactivate`, {
    reason: reason || undefined,
  });
};

export default reactivateVentureUserAssignmentService;
